import React from 'react';
import { Button } from 'junto-ui';
import { PageTitle } from 'components-core';
import BoxWithMargin from '../../BoxWithMargin';
import ErrorIllustration from '../../../../assets/images/ErrorIllustration';

export default () => (
  <>
    <ErrorIllustration />
    <BoxWithMargin
      desktop={{ bottom: '40px', top: '40px' }}
      responsive={{ bottom: '24px', top: '24px' }}
    >
      <PageTitle>Ops! Tivemos um problema técnico. Por favor, tente novamente.</PageTitle>
    </BoxWithMargin>
    <Button variant="primary" size="big" onClick={() => window.location.assign('/')}>
      Tentar novamente
    </Button>
  </>
);
